import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

class DrawerTabsController extends Controller {
  static targets = ['panel', 'tabBtn', 'footer']

  switchTab (e) {
    const tab = e.currentTarget.dataset.tab

    this.panelTargets.forEach(panel => {
      panel.classList.toggle('hidden', panel.dataset.tab !== tab)
    })

    this.tabBtnTargets.forEach(btn => {
      const active = btn.dataset.tab === tab
      btn.classList.toggle('tabs__link-active', active)
    })

    if (this.hasFooterTarget) {
      this.footerTarget.classList.toggle('hidden', tab !== 'appointment')
    }
  }
}

stimulus.register('drawer-tabs', DrawerTabsController)
